import * as React from 'react';
import { INewCardDateTimeIndicatorProps } from './types';
import { Icon, Tooltip } from 'kui';
import './_NewCardDateTimeIndicator.scss';
import { CARD_CLASS } from '../../../../constants';

export function NewCardDateTimeIndicator({
    className,
    icon,
    isAction,
    text,
    tooltip,
    modifier
}: INewCardDateTimeIndicatorProps) {
    const cardDateIndicator = CARD_CLASS + '__new-date-value';
    const cardDateText = CARD_CLASS + '__new-date-text';

    return (
        <Tooltip
            isNoEvents
            isNoWrap
            value={tooltip}
        >
            <span
                className={`
                    ${className || ''}
                    ${cardDateIndicator}
                    ${modifier ? cardDateIndicator + '--' + modifier : ''}
                    ${isAction ? cardDateIndicator + '--action' : ''}
                `}
            >
                {
                    icon &&
                    <Icon xlink={icon}/>
                }
                <span className={cardDateText}>{text}</span>
            </span>
        </Tooltip>
    );
}
